import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '诊后健康管理平台',
  // 后台管理台默认关闭 PWA，避免引入额外的 service worker/caching 复杂度。
  // 只有明确需要离线缓存、安装到桌面或 SW 更新提示时才通过 ENABLE_PWA 打开。
  // 临时开启示例：`ENABLE_PWA=true npm run dev` 或 `ENABLE_PWA=true npm run build`。
  pwa: process.env.ENABLE_PWA === 'true',
  logo: '/image@1x.png',
  iconfontUrl: '',
  collapsed: false, // 默认展开侧边栏
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    header: {
      heightLayoutHeader: 64, // 增加顶栏高度
    },
    pageContainer: {
      paddingBlockPageContainerContent: 12, // 减小上下内边距（默认24）
      paddingInlinePageContainerContent: 24, // 减小左右内边距（默认40）
    },
  },
};

export default Settings;
